<div class="dialog-content-max">
    <form [formGroup]="dataForm">
        <div class="formgrid grid" style="margin-top: 1rem;margin-bottom:2rem;">
            <div class="col-12 lg:col-6 md:col-6 sm:col-12">
                <div class="form-group">
                    <label for="fileextension" class="required-label">
                        File Extension<span style="color: rgb(60, 137, 246);font-size:9px !important;"> (Max 10
                            chars)</span><span>&nbsp;*</span></label>
                    <input pInputText pKeyFilter="text" class="form-control" inputId="fileextension" id="fileextension"
                        formControlName="fileextension" name="fileextension" required placeholder="Enter File Extension"
                        maxlength="10" />
                    <span class="errormessage"
                        *ngIf="dataForm.get('fileextension').invalid && (dataForm.get('fileextension').touched  || dataForm.get('fileextension').dirty)">
                        {{getErrorMessage(dataForm,validation_message,'fileextension')}}
                    </span>
                </div>
            </div>
        </div>

        <div class="custom-dialog-footer">
            <p-button class="m-1" label="Close" styleClass="customeclose" (click)="dismiss()"></p-button>
            <p-button class="m-1" *ngIf="!onlyView" label="{{saveTitle}}" styleClass="customesave"
                (click)="add()"></p-button>
        </div>

    </form>

</div>